import React, { Component } from "react";
import { connect } from "react-redux";

import { TabNavigation, Carousel, PrevStepButton, NextStepButton, Logo } from "components";
import YearItem from "./year-item";
import { MOVE_TAB } from "actions";

class Tab4B extends Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.activeTab === "tab4a" && nextProps.activeTab === "tab4b") {
      return true;
    }
    return false;
  }
  render() {
    const props = this.props;
    return (
      <div className="form_steps">
        <div className="form_steps--inner ">
          <div className="full_column">
            <Logo />
            <TabNavigation />
            <div className="three_blocks">
              <div className="width-1-3">
                <div className="inner_block">
                  <PrevStepButton onClick={props.moveToPreviousTab} text={props.domain.Strings.tab4BPrevBtn} />
                  <h2 className="three_blocks--title">{props.domain.Strings.tab4BTitle}</h2>
                  <NextStepButton text={props.domain.Strings.tab4BNextBtn} hideForMedium onClick={props.moveToNextTab} />
                </div>
              </div>
              <div className="width-2-3">
                {this.props.years.length > 0 && (
                  <Carousel
                    textPrev={props.domain.Strings.tab4BCarouselPrev}
                    textNext={props.domain.Strings.tab4BCarouselNext}
                    children={this.props.years.map(year => {
                      return <YearItem key={year.value} yearValue={year.value} />;
                    })}
                  />
                )}
              </div>
            </div>
            <div className="three_blocks--info">
              <p>
                <strong>{props.domain.Strings.carouselHelpTextStrong}</strong> {props.domain.Strings.carouselHelpText}
              </p>
            </div>
            <NextStepButton text={props.domain.Strings.tab4BNextBtn} showForMedium onClick={props.moveToNextTab} />
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    ...state.app
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    moveToPreviousTab: () => dispatch({ type: MOVE_TAB, dir: "back", from: ownProps.tab }),
    moveToNextTab: () => dispatch({ type: MOVE_TAB, dir: "next", from: ownProps.tab })
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Tab4B);
